export default __webpack_public_path__ + "static/media/gallery-wip-handle_01.f4e336a4.jpg";